import { FAILED, SUCCESS, FETCH_SHORT_LINKS } from '../constants/actionApi';
import { RESET_EVENT, USER_LOGOUT } from '../constants/actionLocal';
import initialState from '../store/initialState';
import { updateObjectInState, resetObjectInState } from '../helpers/data';

export default (state = initialState.shortLinks, { type, payload }) => {
  switch (type) {
    case FETCH_SHORT_LINKS + SUCCESS:
      return updateObjectInState(state, payload.data, true, initialState.shortLinks);
    case FETCH_SHORT_LINKS + FAILED:
    case RESET_EVENT:
    case USER_LOGOUT:
      return resetObjectInState(state, initialState.menuItems);
    default:
      return state;
  }
};
